/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScadenzaCorpoDto } from '../../models/scadenza-corpo-dto';

export interface ApiScadenzeScadenzeCorpoListGet$Params {
    /**
     * Eventuale id del corpo per cui caricare le scadenze
     */
    corpoId?: number;
}

export function apiScadenzeScadenzeCorpoListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiScadenzeScadenzeCorpoListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<ScadenzaCorpoDto>>> {
    const rb = new RequestBuilder(rootUrl, apiScadenzeScadenzeCorpoListGet.PATH, 'get');
    if (params) {
        rb.query('corpoId', params.corpoId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<ScadenzaCorpoDto>>;
        }),
    );
}

apiScadenzeScadenzeCorpoListGet.PATH = '/api/scadenze/scadenze-corpo-list';
